import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ISMultiSelectComponent } from './is-multi-select.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { MatExpansionModule } from '@angular/material/expansion';

const materialModules = [
    MatIconModule,
    MatTooltipModule,
    MatDialogModule,
    MatExpansionModule
];

@NgModule({
    declarations: [ISMultiSelectComponent],
    imports: [
        CommonModule,
        MatMenuModule,
        ReactiveFormsModule,
        SharedModule,
        ...materialModules
    ],
    exports: [ISMultiSelectComponent],
    providers: [],
})
export class ISMultiSelectModule {}